// extracted by mini-css-extract-plugin
module.exports = {"cobrand":"styles_cobrand___7SCv"};